module.exports = __webpack_public_path__ + "img/Comment_ca_marche_1.e13b0f2d.webp";